module.exports = __webpack_public_path__ + "static/media/ic-portfolio-composition.8e11ee25.svg";